module.exports = __webpack_public_path__ + "static/media/logo_pn_nl.fb6b806a.svg";